if (!customElements.get('site-select')) {
  customElements.define(
    'site-select',
    class Select extends HTMLElement {
      constructor() {
        super();
        this.selector = this.dataset.selector || 'select';

        this.select = this.querySelector('select');
        this.selected = this.querySelector('[data-value]');
        if (!this.select) return;
        this.select.addEventListener('change', this.onChangeHandler.bind(this));
      }

      /**
       *
       * @param {string | null} val
       * @returns
       */
      isEmptyOrDash(val) {
        return !val || val === '---';
      }

      onChangeHandler() {
        if (!this.select || !this.selected) return;
        const { selectedIndex, value } = this.select;

        const selected = this.select[selectedIndex];
        const text = selected.textContent;

        if (this.isEmptyOrDash(text) || this.isEmptyOrDash(value)) {
          this.classList.remove(`${this.selector}--has-value`);
        } else {
          this.classList.add(`${this.selector}--has-value`);
        }

        this.selected.textContent = text;
      }
    },
  );
}
